import { getParcelHeatmapReportConfig } from '../config/parcelHeatmapConfig';
import { getDynamicSelectData } from './data';

export const fetchParcelHeatmapData = async ({ company, selectedFilter }) => {
  const reportConfig = getParcelHeatmapReportConfig(selectedFilter['Report Type']);
  
  if (!reportConfig) return [];
  if (!selectedFilter['Origin Type']) return [];

  const isDemoCompany = company === 'GTMS-CP';

  return getDynamicSelectData({
    selectValues: '*',
    tableName: isDemoCompany ? reportConfig.demoReportName : reportConfig.tableName,
    whereField: ['CUSTOMER', 'ORIGIN_STATE'],
    whereOperators: ['=', '='],
    whereValue: [company, selectedFilter['Origin Type']],
    orderBy: 'CUSTOMER',
    db: 'SF',
  });
};
